import "./CabinetCopyrightSection.scss";

const CabinetCopyrightSection = () => {
  const year = new Date().getFullYear();
  return (
    <div className="cabinet-copyright-section">
      <div className="copy-text links">
        <span>
          <a href="/Privacy_Policy.pdf" target="_blank">
            Privacy Policy
          </a>
        </span>
        <span>
          <a href="/Terms_of_Service.pdf" target="_blank">
            Terms of Use
          </a>
        </span>
        <span>
          <a href="/AML_CFT_Policy.pdf" target="_blank">
            KYC / AML policy
          </a>
        </span>
      </div>

      <div className="copy-text">© PAYPILOT {year}. All Rights Reserved</div>
    </div>
  );
};

export default CabinetCopyrightSection;
